import { IconButton, Modal, Paper, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


function UserGroupModal({ open, onFinish, component, ...restProps }) {
    return (
        <Modal
            open={open}
            onClose={onFinish}
            aria-labelledby="user-group-modal-title"
            aria-describedby="user-group-modal-description"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2
            }}
        >
            <Paper 
                elevation={24}
                sx={{
                    position: 'relative',
                    maxWidth: '95vw',
                    maxHeight: '95vh',
                    overflow: 'auto',
                    borderRadius: 2
                }}
            >
                <IconButton
                    onClick={onFinish}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        zIndex: 1,
                        backgroundColor: 'background.paper',
                        '&:hover': {
                            backgroundColor: 'action.hover',
                        }
                    }}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
                <Box sx={{ pt: 2 }}>
                    {open ? component({ onFinish, ...restProps }) : null}
                </Box>
            </Paper>
        </Modal>
    );
}

export default UserGroupModal;